<template>
    <!-- Via https://codepen.io/amiechen/pen/xjvMGb -->
    <div class="relative border rounded mb-4 shadow appearance-none label-floating">
        <input class="w-full py-2 px-3 text-gray-800 leading-normal rounded text-base"
               ref="input"
               :class="{'text-center' : centered, 'cursor-not-allowed': readonly}"
               v-model="value"
               @change="$emit('update:value', $event.target.value)"
               @input="$emit('update:value', $event.target.value)"
               :id="$data._id"
               :name="$data._id"
               type="text"
               :placeholder="label"
               :readonly="readonly">
        <label class="absolute block text-gray-800 top-0 left-0 w-full pb-2 pr-3 leading-normal cursor-text overflow-hidden text-nowrap"
               :for="$data._id"
               :class="{'text-center' : centered}"
               style="padding-top: 0.58rem; padding-left: 0.82rem;"
        >
          {{ label }}
        </label>
        <div    v-if="!readonly && value.length > 0"
                @click="clearValue"
                class="absolute inset-y-0 right-0 pr-3 flex items-center">
            <span class="lnr icon-cross cursor-pointer text-gray-400 hover:text-gray-700"></span>

        </div>
    </div>
</template>

<script>

    // Next ID for the floating Input
    let nextId = 0

    export default {
        name: "FloatingInput",
        emits: ['update:value', 'update:id'],
        props: {
            value: {
                type: [String, Number],
                default: '',
            },
            label: {
                type: String,
                default: 'Label',
            },
            id: {
                type: String,
                default() {
                    return `floating_input`
                },
            },
            centered: {
                type: Boolean,
                default: false,
            },
            readonly: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                _id: this.id,
            }
        },
        created() {
            this.updateId()
        },
        methods: {
            clearValue() {
                this.$emit('update:value', '')
            },
            updateId() {
                let newId = this.id
                if (this.id === 'floating_input') {
                    newId += `_${nextId++}`
                }

                this.$data._id = newId
            },
        },
        watch: {
            id() {
                this.$data._id = this.id
                this.updateId()
            },
            _id(val, old) {
                if (val === old) {
                    return
                }

                this.$emit('update:id', val)
            },
        },
    }
</script>

<style scoped>
    .label-floating input:not(:placeholder-shown) {
        padding-top: 1.4rem;
    }
    .label-floating input:not(:placeholder-shown) ~ label {
        font-size: 0.7rem;
        transition: all 0.2s ease-in-out;
        font-weight: 700;
        color: #1A56DB;
    }
    .label-floating input:placeholder-shown ~ label {
        font-size: 1rem;
        font-weight: 500;
        transition: all 0.1s ease-in-out;
    }
</style>